import { createApp } from 'vue';
import { safeDefine } from '@breuni-ui/safe-define';

export default class ProductFamily extends HTMLElement {
  connectedCallback() {
    Promise.all([import('./product-family.vue.component.js'), import('../carousel/index.js')]).then(
      ([{ default: productFamilyVueComponent }]) => {
        this.createVueInstance(productFamilyVueComponent);
      },
    );
  }

  createVueInstance(productFamilyVueComponent: typeof import('./product-family.vue.component.js').default) {
    const gridRow = this.closest('.ents-reco-container__grid-row') as Element;

    const app = createApp(productFamilyVueComponent(this, gridRow) as unknown as Parameters<typeof createApp>[0]);

    app.config.compilerOptions.isCustomElement = (tag: string) =>
      /^shop-|^bewerten-|^ents-|^suchen-|^kaufen-|^entd-|^brtn-|^camp-|^reco-|^additional-price-info|^loyl-/.test(tag);
    app.config.compilerOptions.whitespace = 'preserve';
    app.config.compilerOptions.delimiters = ['[[', ']]'];

    app.mount(this);
  }
}

document.addEventListener(
  'bewe:ents:vue-ready',
  () => {
    safeDefine('ents-product-family', ProductFamily);
  },
  { once: true },
);
